import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Documento } from '../../cliente/documento.model';
import { SnackService } from '../../shared-services/snack.service';
import { ClienteService } from '../../core/cliente.service';
import { BackendService } from '../../core/backend.service';
import { Cliente } from '../../cliente/cliente.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { EstadoCliente } from '../../cliente/estadoCliente.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Producto } from '../../productos/producto.model';
import { ImagenService } from '../../core/imagen.service.';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../cliente/parametric.model';
import { Observable } from 'rxjs/Observable';
import { ImagenBannerDto } from '../imagen-bannerDto.model';
import { ImagenBanner } from './imagen-banner.model';
import { Banner } from '../banner.model';
import { CategoriaDto } from '../../productos/categoria-producto/categoriaDto.model';
import { CategoriaProducto } from '../../productos/categoria-producto/categoria-producto.model';

@Component({
  selector: 'app-banner-imagen-upload',
  templateUrl: './banner-imagen-upload.component.html',
  styleUrls: ['./banner-imagen-upload.component.scss']
})
export class BannerImagenUploadComponent implements OnInit {
  @Input() imagenes: ImagenBannerDto[];
  //@Input() coloresPosibles: OperationalParametric[];
  //@Input() tiposImagenes: Observable<Parametric[]>;

  private re = /(?:\.([^.]+))?$/;
  private EstadoCliente = new EstadoCliente();
  seleccionarArchivo = 'Seleccionar imágen';
  public categoriasList: CategoriaProducto[];
  public tiposDeImagen: String[] = ["Desktop","Mobile"];

  constructor(
    private clienteService: ClienteService,
    private backendService: BackendService,
    private snackService: SnackService,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiService,
    private dialogService: DialogService) { }

  async ngOnInit() {
    this.imagenes.forEach(i => {
      if (i.path && i.path.indexOf('http') < 0) {
        this.getImages(i);
      } else {
        i.path = i.path + i.nombre;
      }
    });
    await this.getCategorias();
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  getImages(imagen: ImagenBannerDto) {
    this.clienteService.getImagenById(imagen.id).subscribe(data => {
      const urlCreator = window.URL;
      const safeUrl: any = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
      imagen.path = safeUrl;
    });
  }

  agregarImagen() {
    this.imagenes.push(new ImagenBannerDto(undefined));
  }

  eliminarImagen(index: number) {
    if (this.imagenes[index].id) {
      this.dialogService.confirm('Eliminar archivo',
      '¿Está seguro que desea eliminar la imagen ' + this.imagenes[index].nombre
       + '?')
      .then( res => {
        if (res) {
          this.deleteFromDb(this.imagenes[index].id);
          this.imagenes.splice(index, 1);
          if (this.imagenes.length === 0) {
            this.imagenes.push(new ImagenBannerDto(undefined));
          }
        }
      });
    } else {
      this.imagenes.splice(index, 1);
    }
  }

  deleteFromDb(id: number) {
    this.backendService.delete(Banner.path + id)
  }

  addFile(event, index: number) {
    if (this.soloImagenesOPdf(event.target.files[0].name)) {
      this.imagenes[index].file = event.target.files[0];
      this.imagenes[index].path = event.target.files[0].path;
      this.imagenes[index].nombre = event.target.files[0].name;
    }
  }

  soloImagenesOPdf(fileName: string) {
    let ext = this.re.exec(fileName)[1];
    ext = ext.toLowerCase();
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'svg' && ext !== 'jpeg' && ext !== 'gif' && ext !== 'pdf') {
      this.snackService.error('Solo estan permitidos archivos de tipo ".png", ".jpg", ".svg", ".jpeg", ".gif" o ".pdf"');
      return false;
    }
    return true;
  }
  
  async getCategorias(){
    await this.backendService.get(CategoriaProducto, CategoriaProducto.path + "all", null).toPromise().then(a =>{
      this.categoriasList = a;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/banner-imagen-upload/banner-imagen-upload.component.ts